package com.partejar.app.core.network

import com.partejar.app.core.di.PRODUCTION_API_BASE_URL
import io.ktor.client.HttpClient
import io.ktor.client.request.get
import io.ktor.http.HttpStatusCode

internal enum class PublicLinkApiProtocol { CURRENT, LEGACY }

private const val LEGACY_PROBE_PATH = "/assinaturas/contratos/codex-compatibility-probe-no-secret"

/** Legacy bearer URLs are permitted only while the known production API is still behind Caddy. */
internal class PublicLinkApiProtocolResolver(
    private val client: HttpClient,
    private val config: ApiConfig
) {
    private var cached: PublicLinkApiProtocol? = null

    suspend fun resolve(): PublicLinkApiProtocol {
        cached?.let { return it }
        val status = client.get(config.endpoint("/actuator/health")).status
        val knownProductionApi = config.baseUrl.trimEnd('/') == PRODUCTION_API_BASE_URL
        val legacyProbeStatus = if (knownProductionApi &&
            (status == HttpStatusCode.OK || status == HttpStatusCode.Unauthorized)
        ) client.get(config.endpoint(LEGACY_PROBE_PATH)).status else null
        val protocol = when {
            legacyProbeStatus == HttpStatusCode.Gone -> PublicLinkApiProtocol.LEGACY
            status == HttpStatusCode.OK &&
                (legacyProbeStatus == null || legacyProbeStatus == HttpStatusCode.Unauthorized ||
                    legacyProbeStatus == HttpStatusCode.NotFound) -> PublicLinkApiProtocol.CURRENT
            else -> error("Não foi possível identificar o protocolo de links públicos da API.")
        }
        if (protocol == PublicLinkApiProtocol.CURRENT) cached = protocol
        return protocol
    }
}
